import definitions from '../../../assets/i18n/languages.json';
import english from '../../../assets/i18n/en.json';

export const languageDefinitions = definitions;
export function languageInfo(value: string) {
  const normalized = value?.trim().toLowerCase() || '';
  const primary = definitions.find(l => l.code === normalized.split('-')[0]);
  const alias = ({chinese:'zh-Hans', mandarin:'zh-Hans', 'zh-cn':'zh-Hans', 'zh-hans':'zh-Hans', cambodian:'km', khmer:'km'} as Record<string,string>)[value?.trim().toLowerCase()];
  return definitions.find(l => l.code.toLowerCase() === (alias || value)?.trim().toLowerCase() || l.name.toLowerCase() === value?.trim().toLowerCase()) || primary || definitions[0];
}
let activeCode = 'en';
export function activeLanguage() { return languageInfo(activeCode); }
let dictionary: Record<string,string> = english;
const englishKeys = new Map(Object.entries(english).map(([key,value]) => [value,key]));
export function setTranslations(values: Record<string,string>, language = 'en') { activeCode = languageInfo(language).code; dictionary = {...english, ...values}; }
export function resourceText(key: string, params?: Record<string,string|number>): string {
  key = key?.trim();
  if (!key) return '';
  if (typeof params?.count === 'number') {
    const suffix = new Intl.PluralRules(activeLanguage().locale).select(params.count).toUpperCase();
    const pluralKey = key + '_' + suffix;
    if (dictionary[pluralKey] || dictionary[key + '_OTHER']) key = dictionary[pluralKey] ? pluralKey : key + '_OTHER';
  }
  const text = dictionary[key]?.trim() ? dictionary[key] : english[key]?.trim() ? english[key] : key;
  return params ? text.replace(/\{(\w+)\}/g, (whole,name) => params[name] === undefined ? whole : String(params[name])) : text;
}
export function translatedText(text: string): string {
  const key = englishKeys.get(text);
  return key ? resourceText(key) : text;
}
